import React from 'react';

export const sat_national = {
  digitalProctorScript: <p className='mb-4'>Start code not found. Your test coordinator should call us.</p>,
  legal: (
    <React.Fragment>
      <p className='mb-4'>
        You&rsquo;re almost there&mdash;we just need you to read and accept (1) the SAT Testing Staff Agreement and (2)
        the Test Day Toolkit Agreement.
      </p>

      <h2 className='tdtk-h2 text-center text-uppercase' data-automation='heading-h2'>
        (1) <u>SAT TESTING STAFF AGREEMENT</u>
      </h2>

      <p className='mb-4'>As a testing staff person, I affirm that I:</p>
      <ul>
        <li>
          Have read and agree to all rules and guidelines set forth in the applicable SAT manual, including, but not
          limited to, the pages setting forth conditions under which the SAT must be administered and the information on
          staff qualifications and conflict of interest restrictions.
        </li>
        <li>
          Am a high school graduate, at least 18 years old, speak English fluently, possess the same level of
          unquestionable integrity and maturity expected of a member of the school staff, and act in a fair, courteous,
          nondiscriminatory, and professional manner.
        </li>
        <li>
          Understand and agree that all SAT tests, and all the questions contained in them, are the property of College
          Board and protected by copyright law, and that no one other than the student or authorized reader for College
          Board&ndash;approved accommodations can open a test book and see the test content.
        </li>
        <li>
          Understand and agree that copying, reproducing, or removing any materials from any SAT test book or digitally
          reproduced test form is prohibited.
        </li>
        <li>Am not prohibited by any law or regulation from working with minors or on school property.</li>
        <li>
          Am not engaged in any private SAT test preparation conducted outside the auspices of my school or district for
          compensation and will not engage in such activity for the remainder of the current school year. (The teaching
          and normal review of course content, including test familiarization, that is part of regularly scheduled
          school coursework is acceptable.)
        </li>
        <li>Have not taken any SAT test within 180 days of the test date.</li>
        <li>
          Do not have a member of my household or immediate family (&ldquo;related student&rdquo;) taking the SAT on the
          test date at any testing site. (Immediate family includes parents, siblings, children, grandparents, and
          spouse. This applies even if they don&rsquo;t reside in the same household.) In such instances, the related
          student&rsquo;s scores are subject to cancellation.
        </li>
        <li>
          Understand and agree that providing any assistance or coaching to students on the SAT (including directing or
          changing answers) prior to, during, or after the administration is prohibited. In such instances, any impacted
          students&rsquo; scores are subject to cancellation, and any staff involved may be referred to
          school/district/state administration or to law enforcement, as appropriate.
        </li>
        <li>
          Will act with integrity and will refrain from any illegal or unethical acts, including those that attempt to
          provide an unfair advantage for one or more test takers.
        </li>
      </ul>

      <p className='mb-4'>
        All staff, including test coordinators, proctors, room monitors, and hall monitors, must accept these provisions
        by clicking the <strong>Submit</strong> button below. College Board has the right, in its sole discretion, to
        remove or bar staff who violate these terms from administering future College Board tests.
      </p>

      <p className='mb-4'>
        <strong>IMPORTANT:</strong> Test coordinators will ensure that all testing staff are properly trained to
        administer a secure administration. Test coordinators will not discuss details about test policies or procedures
        (e.g., handling test materials, training, and packaging for return) with anyone other than their staff,
        including the media or through social media. Test coordinators will refer all media questions to the customer
        support phone number as listed in your manual.
      </p>

      <h2 className='tdtk-h2 text-center text-uppercase' data-automation='heading-h2'>
        (2) <u>SAT TEST DAY TOOLKIT AGREEMENT</u>
      </h2>

      <p className='mb-4'>
        This AGREEMENT (this &ldquo;<strong>Agreement</strong>&rdquo;) is made by and between College Board, a
        not-for-profit education corporation organized under the laws of the State of New York (the &ldquo;
        <strong>College Board</strong>&rdquo;), and the person receiving this Agreement (&ldquo;You&rdquo; or
        &ldquo;Your&rdquo;), as of the date of execution by both parties.
      </p>

      <h3 className='tdtk-h3 text-center legal__title-small' data-automation='heading-h3'>
        Recitals
      </h3>

      <p className='mb-4'>
        College Board will provide a web-based toolkit (&ldquo;Test Day Toolkit&rdquo;) that allows SAT testing staff to
        perform certain test day&ndash;related functions online. Test Day Toolkit is further described in Attachment A
        to this Agreement.
      </p>

      <h3 className='tdtk-h3 text-center legal__title-small' data-automation='heading-h3'>
        Agreement
      </h3>

      <p className='mb-4'>
        In consideration of the mutual covenants and promises herein contained, the adequacy of which is hereby
        acknowledged, You and College Board agree as follows:
      </p>

      <ol>
        <li>
          <u>Right to Use</u>. College Board grants to You a nonexclusive, nontransferable, revocable right to access
          and use Test Day Toolkit solely for the purposes set forth herein and in accordance with the SAT Staffing
          Agreement. You agree to use Test Day Toolkit only in connection your role as SAT staff. You understand that
          College Board is not granting to You any license to the underlying technologies, calculations, and
          methodologies that compose Test Day Toolkit or the supporting services.
        </li>
        <li>
          <u>Ownership</u>. You understand and acknowledge that all title, proprietary and intellectual property rights
          in and to Test Day Toolkit are owned solely by College Board, including copyright, trade secrets, and
          trademarks. You acknowledge and agree that Test Day Toolkit is protected under U.S. laws and international
          treaties. You have a limited right to use Test Day Toolkit in accordance with the terms of this Agreement. You
          agree not to change, alter, or modify Test Day Toolkit or any related materials, and not to disassemble,
          decompile, reverse-engineer, or otherwise translate any software incorporated in Test Day Toolkit or any
          related materials.
        </li>
        <li>
          <u>Feedback</u>. You agree to allow College Board to send You an optional survey to provide You an opportunity
          to give College Board reasonable suggestions, comments, and feedback, including, but not limited to,
          usability, bug reports, and test results, with respect to Your use of Test Day Toolkit (collectively, &ldquo;
          <strong>feedback</strong>&rdquo;). You agree that we can use Your quotes or testimonials, in a deidentified
          way, in promotional or other materials. You acknowledge and agree that College Board may freely use, disclose,
          reproduce, license, distribute, and otherwise commercialize any feedback, whether oral or written, provided to
          College Board by You with respect to the Service.
        </li>
        <li>
          <u>Confidentiality and Data Security</u>. In connection with Test Day Toolkit, You agree not to disclose to
          third parties: (i) any information received from College Board; and (ii) information pertaining to Test Day
          Toolkit. You also agree: (i) to keep Your mobile device with You during testing; (ii) to notify College Board
          should Your mobile device become missing during the test administration; (iii) not to disclose test taker
          personal information to anyone other than testing staff for purposes of completing the test administration;
          and (iv) not to misuse, transfer, or copy test taker personal information.
        </li>
        <li>
          <u>GENERAL DISCLAIMER</u>. COLLEGE BOARD DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING,
          WITHOUT LIMITATION, ANY IMPLIED REPRESENTATIONS OR WARRANTIES OF MERCHANTABILITY, OR FITNESS FOR A PARTICULAR
          PURPOSE. COLLEGE BOARD DOES NOT REPRESENT OR WARRANT THAT TEST DAY TOOLKIT WILL BE UNINTERRUPTED OR
          ERROR-FREE, OR THAT ALL DEFICIENCIES OR ERRORS ARE CAPABLE OF BEING CORRECTED.
        </li>
        <li>
          <u>LIMITATION OF LIABILITY</u>. EXCEPT TO THE EXTENT FINALLY DETERMINED TO BE PROHIBITED BY LAW, IN NO EVENT
          WILL COLLEGE BOARD OR ITS AFFILIATES HAVE ANY LIABILITY WHATSOEVER, INCLUDING, BUT NOT LIMITED TO, DIRECT,
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES (EVEN IF WE HAVE BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES) IN CONTACT, TORT, OR OTHERWISE TO YOU OR ANY THIRD PARTY ARISING FROM, RELATING
          TO, OR IN CONNECTION WITH THIS AGREEMENT.
        </li>
        <li>
          <u>Publicity</u>. You may not use College Board name or trademarks for any reason, including, without
          limitation, for marketing or publicity purposes.
        </li>
        <li>
          <u>Governing Law</u>. This Agreement shall be governed in all respects by the laws of the State of New York
          without regard to principles in respect of conflict of law.
        </li>
        <li>
          <u>No Third-Party Beneficiaries</u>. Each party intends that this Agreement shall not benefit, or create any
          right or cause of action in or on behalf of, any person or entity other than College Board and You.
        </li>
      </ol>

      <h3 className='tdtk-h3 text-center legal__title-small' data-automation='heading-h3'>
        ATTACHMENT A TO SAT TEST DAY TOOLKIT AGREEMENT
      </h3>

      <p className='mb-4'>
        <u>What</u>: College Board is providing Test Day Toolkit, a web-based tool accessible via mobile phone, tablet,
        and desktop computer that allows test center staff (test center supervisors/coordinators, associate
        supervisors/proctors, and monitors) administering the SAT to, among other items,:
      </p>

      <ul>
        <li>Manage test center staff</li>
        <li>Assign staff and students to testing rooms</li>
        <li>Check in students on test day</li>
        <li>Manage student rosters</li>
        <li>Generate final student rosters</li>
        <li>Capture/collect test day irregularities (student- and group-level)</li>
      </ul>
      <p className='mb-4'>
        <u>Support and Training</u>: College Board will provide users with helpful resources within Test Day Toolkit.
        Educational Testing Service (&ldquo;ETS&rdquo;) will answer any questions about the tool.
      </p>
      <p className='mb-4'>
        By clicking <strong>Submit</strong>, I acknowledge that I have read and accept the terms of (1) the SAT Testing
        Staff Agreement and (2) the SAT Test Day Toolkit Agreement.
      </p>
    </React.Fragment>
  ),
  homeIntroHelpText: (
    <React.Fragment>
      <h2 className='tdtk-h2 py-4' id='do-you-need-help-header'>
        Do you need help?
      </h2>
      <p className='mb-2'>
        To sign in for the first time, you need a personalized access email. If you didn’t get an email:
      </p>
      <ul className='mb-4'>
        <li>Check your junk email folder.</li>
        <li>Ask your test coordinator for help.</li>
        <li>If you are a coordinator, use the information in your manual to contact us.</li>
      </ul>
      <p className='mb-4'>
        Step-by-step instructions and more troubleshooting tips are available on{' '}
        <a
          href='https://bluebook.collegeboard.org/test-admin/test-day-toolkit-access/'
          rel='noopener noreferrer'
          target='_blank'
        >
          First-Time Access to Test Day Toolkit
        </a>
        .
      </p>
    </React.Fragment>
  ),
  voucherIntro: (
    <React.Fragment>
      <p className='mb-4'>
        Use the information shown here to create payment vouchers at{' '}
        <a href='https://supervisor.ets.org/Supervisor/' rel='noopener noreferrer' target='_blank'>
          ets.org/supervisor
        </a>{' '}
        after testing.
      </p>
      <p className='mb-4'>
        <strong>IMPORTANT:</strong> Make sure your roster is updated with attendance data first.
      </p>
    </React.Fragment>
  ),
  voucherStandardStudentIntro: (
    <React.Fragment>
      <h2 className='tdtk-h2 py-4'>Standard Attendance Information</h2>
      <p className='mb-4'>Use this table to complete step 2 of creating a standard ETS voucher.</p>
    </React.Fragment>
  ),
  voucherStandardStaffIntro: (
    <React.Fragment>
      <h2 className='tdtk-h2 py-4'>Standard Staff Role Information</h2>
      <p className='mb-4'>Use this table to complete step 4 of creating a standard ETS voucher.</p>
    </React.Fragment>
  ),
  voucherAccommodatedStudentIntro: (
    <React.Fragment>
      <h2 className='tdtk-h2 py-4'>Accommodated Attendance Information</h2>
      <p className='mb-4'>Use this table to complete step 2 of creating an accommodated ETS voucher.</p>
    </React.Fragment>
  ),
  voucherAccommodatedStaffIntro: (
    <React.Fragment>
      <h2 className='tdtk-h2 py-4'>Accommodated Staff Role Information</h2>
      <p className='mb-4'>Use this table to complete step 4 of creating an accommodated ETS voucher.</p>
    </React.Fragment>
  ),
  voucherSubjectTestsMessage: (
    <td colSpan={4}>
      <p className='mb-4'>
        <strong>Important:</strong> If you had any accommodated rooms for SAT Subject Tests with Listening, subtract
        those numbers from the totals shown below and report them separately on the ETS voucher.
      </p>
    </td>
  ),
  welcomeModal: (
    <div className='videoWrapper mb-4'>
      <iframe
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        frameBorder='0'
        height='315'
        src='https://www.youtube.com/embed/bC-nsGegSng?rel=0&ref=0&modestbranding=1'
        title='YouTube - College Board Test Day Toolkit First Time Access'
        width='560'
      ></iframe>
    </div>
  ),
};
